module.exports = __webpack_public_path__ + "fonts/icomoon.b8e48cd2.woff";